import React from 'react';
import { faPlus, faListUl, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ordersTableData } from '../../data/orders';
import useAdvanceTable from '../../hooks/useAdvanceTable';
import AdvanceTableProvider from '../../providers/AdvanceTableProvider';
import { Col, Row, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Bars } from 'react-loader-spinner';
import CardViewItem from '../../components/sales-management/CardViewItem';
import AdvanceTableFooter from '../../components/base/AdvanceTableFooter';
import { useAppContext } from '../../providers/AppProvider';
import { useOrderContext } from '../../providers/OrderProvider';
import { ordersTableColumns } from '../../components/tables/OrdersTable';
import OrderTopSection from './OrdersTopSection';
import { useOrders } from '../../features/orders/useOrders';
import CompletedOrdersPanel from '../../components/sales-management/CompletedOrdersPanel';
import { useState } from 'react';

export const columns = [
  {
    // For filtering and searching projects by status
    id: 'status',
    accessorFn: ({ status }) => status
  },
  {
    // For searching projects by name
    accessorKey: 'name'
  }
];

const OrderCardView = () => {
  // 'active' | 'completed'. The card grid shows live orders; a finished one has
  // left Redis for the archive, so it needs its own, server-paged list.
  const [view, setView] = useState('active');

  const {
    config: { theme }
  } = useAppContext();

  const {
    data: orders = [],
    isLoading,
    isFetching,
    isError,
    error
  } = useOrders();

  const table = useAdvanceTable({
    data: orders,
    columns: columns,
    pageSize: 8,
    pagination: true,
    sortable: true,
    selection: true
  });

  if (isLoading) {
    return (
      <Bars
        height="80"
        width="80"
        radius="9"
        color={theme === 'dark' ? 'white' : '#3874ff'}
        ariaLabel="three-dots-loading"
        wrapperStyle={styles.spinnerContainer}
      />
    );
  }

  return (
    <div>
      <AdvanceTableProvider {...table}>
        <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
          <h2 className="mb-0">
            <span className="me-3">Orders</span>{' '}
            <span className="fw-normal text-700">({orders.length})</span>
          </h2>
          <Link
            className="btn btn-primary px-5"
            to="/apps/project-management/create-new"
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Add new order
          </Link>
        </div>
        <Nav variant="pills" className="mb-3 gap-2">
          <Nav.Item>
            <Nav.Link
              active={view === 'active'}
              onClick={() => setView('active')}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faListUl} className="me-2" />
              Active
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={view === 'completed'}
              onClick={() => setView('completed')}
              style={{ cursor: 'pointer' }}
            >
              <FontAwesomeIcon icon={faCircleCheck} className="me-2" />
              Completed
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {view === 'completed' ? (
          <CompletedOrdersPanel />
        ) : (
          <>
            <OrderTopSection activeView="card" />
            <Row className="g-3 mb-9">
              {table
                .getRowModel()
                .rows.map(row => row.original)
                .map(project => (
                  <Col xs={12} sm={6} xl={4} xxl={3} key={project._id}>
                    <CardViewItem project={project} />
                  </Col>
                ))}
            </Row>
            <AdvanceTableFooter pagination />
          </>
        )}
      </AdvanceTableProvider>
    </div>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Add a background with some opacity
    zIndex: 1000 // Ensure the spinner is on top
    // backgroundColor: '#000', // Optional: background color
  }
};

export default OrderCardView;
